import { API_BASE_URL, ADMIN_SECRET } from '../utils/constants';

const API_URL = `${API_BASE_URL}/api/products`;
export const fetchHomeContent = async () => {
  const response = await fetch(`${API_URL}/home-content`);

  if (!response.ok) {
    throw new Error('Failed to fetch home content');
  }

  return response.json();
};

export const updateHomeContent = async (data) => {
  const response = await fetch(`${API_URL}/home-content`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      headers: { 'admin-secret': `${ADMIN_SECRET}` }
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error('Failed to update home content');
  }

  return response.json();
};